<template>
    <DashboardEditSection class="SubscriptionView" title="Subscription">
            <h2>Subscription</h2>
            <div v-if="subscription">
                <p>Status: <strong>{{ subscription.status }}</strong></p>
                <p>Expires on: <strong>{{ subscription.endsAt | formatDate }}</strong></p>
                <p>Drivers: <strong>{{ subscription.quantity }}</strong></p>
                <div class="actions">
                    <p v-if="!trialCanBeReset">You cannot reset active subscriptions</p>
                    <Button
                        class="primary danger"
                        style="float: right"
                        :disabled="!trialCanBeReset"
                        @click="handleResetTrial"
                    >Reset Trial</Button>
                </div>
            </div>
            <div v-else>
                <p>There is no subscription associated with this company.</p>
                <p v-if="user.role === 'admin'">
                    When the owner signs in, they will be redirected to the billing page to create their subscription.
                </p>
            </div>
    </DashboardEditSection>
</template>


<script>
import * as api from '@/api';
import { mapState } from 'vuex';
import DashboardEditSection from '@/components/DashboardEditSection';
import ConfirmModal from '@/components/modals/ConfirmModal';

export default {
    name: 'SubscriptionView',

    components: { DashboardEditSection },

    computed: {
        ...mapState('auth', ['user']),
        ...mapState('company', ['id', 'subscription']),

        trialCanBeReset() {
            return ['canceled', 'past_due'].includes(this.subscription.status);
        },
    },

    methods: {
        handleResetTrial() {
            const title = 'Reset Trial';
            const message = 'This will remove any inactive subscription and allow the user to sign up for another trial period.';

            const onConfirm = async () => {
                const res = await api.resetTrial(this.id);
                if (res.error) return this.$awn.alert('Failed to reset trial');

                this.$awn.success('Trial has been reset');
                await this.$store.dispatch('company/fetchOverview');
            };

            this.$modal.show(
                ConfirmModal,
                { title, message, type: 'delete', confirmLabel: 'Reset Trial', onConfirm },
                { height: 'auto' },
            );
        },
    },
};
</script>


<style lang="scss" scoped>
.SubscriptionView {
    .actions {
        display: flex;
        justify-content: right;
        align-items: center;

        p {
            margin-right: 15px;
        }
    }
}
</style>
